<ng-container class="breadcrumb" *ngFor="let crumb of breadcrumbProvider.currentCrumbs; let i = index">
    <ng-container *ngIf="i < breadcrumbProvider.currentCrumbs.length - 1">
        <button class="crumb-btn"
                mat-button
                color="accent"
                (click)="breadcrumbProvider.onCrumbClicked(crumb)">
            {{ crumb.shortTitle | translate }}
        </button>
        <span class="separator">/</span>
    </ng-container>
    <ng-container *ngIf="i == breadcrumbProvider.currentCrumbs.length - 1">
        <button class="crumb-btn"
                mat-button
                disabled
                color="primary">
            {{ crumb.title | translate }}
        </button>
    </ng-container>
</ng-container>
